/** Free-tier dashboard history window (days visible, inclusive of cutoff day). */
export const FREE_DASHBOARD_HISTORY_DAYS = 7;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/** @returns {string} YYYY-MM-DD in local timezone */
export const toLocalDateStr = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/**
 * Oldest scheduled date still visible for Free dashboard history.
 * Tasks with dateStr < cutoff are excluded at query level.
 * @param {Date|string} [fromDate]
 * @returns {string}
 */
export const getFreeHistoryCutoffDateStr = (fromDate = new Date()) => {
  const base =
    fromDate instanceof Date
      ? new Date(fromDate)
      : new Date(`${fromDate}T12:00:00`);
  base.setHours(12, 0, 0, 0);
  base.setTime(base.getTime() - FREE_DASHBOARD_HISTORY_DAYS * MS_PER_DAY);
  return toLocalDateStr(base);
};

/** @param {string|null|undefined} dateStr @param {string|null|undefined} cutoffDateStr */
export const isOnOrAfterHistoryCutoff = (dateStr, cutoffDateStr) => {
  if (!cutoffDateStr || !dateStr) return true;
  return dateStr >= cutoffDateStr;
};
